import { Typography, Stack } from '@mui/material';
import { Link } from 'gatsby-plugin-react-i18next';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';

const LinkTypography = ({ label }) => (
  <Typography
    color="white"
    variant="body2"
    sx={{
      transition: 'color 0.3s ease',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
        color: 'primary.light',
      },
    }}
  >
    {label}
  </Typography>
);

const LinkList = ({ title, links }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="column" gap="12px">
      <Typography color="primary.light" variant="body2">
        {t(title)}
      </Typography>
      {links.map((link) => {
        if (link.text === "Preferencias de cookies" || link.text === "No vendas o compartas mi información personal") {
          return (<a
            key={link.text}
            href={"#"}
            style={{ textDecoration: 'none' }}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(evt) => {
              evt.preventDefault()
              return typeof window != "undefined" && window.Osano && window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')

            }}

          >
            <LinkTypography label={t(link.i18n)} />
          </a>)

        }
        return (<>
          {link.external ? (
            <a
              key={link.text}
              href={link.to}
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkTypography label={t(link.i18n)} />
            </a>
          ) : (
            <Link key={link.text} to={link.to} style={{ textDecoration: 'none' }}>
              <LinkTypography label={t(link.i18n)} />
            </Link>
          )}
        </>
        )
      })}
    </Stack>
  );
};

export default LinkList;
